import axios from "axios";

export function getClassById(classId) {
  const config = {
    params: {
      classId: classId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "student/studentbyclassid", config);
}

export function getClassList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/classList", config);
}
export function getInactiveClassesList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/inactiveclasseslist", config);
}

export function getInactiveClassList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/inactiveclasses", config);
}

export function setClassInactive(classId) {
  const config = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Class/inactive", classId, config);
}

export function getLecturerInfo(lecturerId) {
  const config = {
    params: {
      lecturerId: lecturerId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/lecturerinfo", lecturerId ? config : "");
}

export function updateClass(data) {
  data.LevelsId = data.levelsId;
  data.Name = data.name;
  data.ClassPersonelAddUpdateDto = {classID : data.id , personelId : data.lecturerId} 
  //console.log("data",data);
  return axios.put(process.env.VUE_APP_API_URL + "Class/update", data);
}

export function deleteClass(classId) {
  const config = {
    params: {
      classId: classId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Class/deleted", config);
}

/*** YENİ OYS */
//Sınıf Atlatma
export function postClassLevelUp(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/levelUp", data);
}

export function postClassLevelUpExistClass(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/ClassLevelUpExistClass", data);
}

export function checkClassLevelUp(classId) {
  const config = {
    params: {
      classId: classId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/checkClassLevelUp", config);
}
//!Sınıf Atlatma

//Sınıf ekle
export function postNewClass(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/add", data);
}

//Döneme Göre Sınıf listesi
export function getClassAssignmentList(centerPeriodId) {
  const config = {
    params: {
      centerPeriodId: centerPeriodId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/classassignment", config);
}

//Sınıfa Öğrenci atama
export function postClassAssignment(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/classassignmentadd", data);
}

export function saveClassAssignments(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/classassignmentaddvtwo", data);
}

//Seviye Listesi
export function getLevelList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/level");
}

//Uyruk Listesi
export function getNationalityList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/nationality");
}

//Cinsiyet Listesi
export function getGenderList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/gender");
}

//Sınıfa atanmış okutman listesi
export function getLecturerListByClassId(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/personlist", config);
}

//Sınıfa Okutman atama
export function postLecturerToClass(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/personadd", data);
}

//Sınıftaki Okutmanı güncelleme
export function updateLecturerToClass(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Class/personupdate", data);
}

//Sınıfa Okutman Pasife Çekme
export function deleteLectuerToClass(id) {
  const config = {
    params: {
      id: id,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Class/persondeleted", config);
}

//Toplu öğrenciye sınıf açıp atama
export function postClassAssignmentStudents(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/SaveAssingmentClass", data);
}

//Toplu öğrencileri var olan sınıfa atama
export function postClassAssignmentStudentsMore(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Class/classassignmentaddmore", data);
}

export function getClassListToPlaylistForTeacher(playlistid) {
  const config = {
    params: {
      playlistid: playlistid
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/getclasslisttoplaylistforteacher", config);
}

export function getClassListToVideoForTeacher(videoid) {
  const config = {
    params: {
      videoid: videoid
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/getclasslisttovideoforteacher", config);
}

export function getQueryClassList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/ClassListV2", config);
}
